import { removeUndefinedAndNullProperties } from 'lib/object/objectUtils'

/**
 * Leaf helper for stripping null/undefined Snowplow context data fields.
 * Kept out of helpers.ts so event context modules can use it without
 * pulling the helpers hub (and the offerContext ↔ helpers cycle).
 */
export function filterDefinedProperties(contexts: Array<{
  schema: string
  data: Record<string, unknown>
}>) {
  return contexts.map((context) => {
    const contextClone = { ...context }

    const data = contextClone.data
    const definedProperties = removeUndefinedAndNullProperties(data)

    return {
      ...context,
      data: definedProperties,
    }
  })
}
